import { SizeVariant } from '../../types';

export const STANDARD_BUTTON_HORIZONTAL_PADDING_CLASSNAME: Record<
  SizeVariant,
  string
> = {
  xs: 'px-2',
  sm: 'px-6',
  base: 'px-5',
  lg: 'px-5',
  xl: 'px-5',
};

export const STANDARD_BUTTON_VERTICAL_PADDING_CLASSNAME: Record<
  SizeVariant,
  string
> = {
  xs: 'py-1',
  sm: 'py-2',
  base: 'py-2',
  lg: 'py-3',
  xl: 'py-3',
};

export const STANDARD_BUTTON_TEXT_SIZE_CLASSNAME: Record<SizeVariant, string> =
  {
    xs: 'text-xs',
    sm: 'text-xs',
    base: 'text-sm',
    lg: 'text-sm',
    xl: 'text-sm',
  };
